import styled from '@emotion/styled';
import { Tab as MuiTab, Tabs as MuiTabs } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { skipDisabledPropOption, getMainColor } from '../styles';

type Theme = {
  theme?: ICustomTheme;
};

export const Tab = styled(MuiTab)<Theme>(({ theme }) => ({
  marginRight: theme.spacing(3),
  minHeight: 'unset',
  minWidth: 'unset',
  padding: 0,
  textTransform: 'initial',
}));

export const Tabs = styled(
  MuiTabs,
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  marginBottom: theme.spacing(3),
  minHeight: 'unset',
  '& .MuiTabs-indicator': {
    backgroundColor: getMainColor(theme, isDisabled),
  },
}));

export const Container = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
});
